import virtualFactory from "../virtualFactory";

function clarityStoreFactory(optionType) {
  return virtualFactory("option", "optionId", "optionType", optionType);
}

export default {
  clarityServicePrimaryCare: clarityStoreFactory("servicePrimaryCare"),

  clarityServiceSpecialty: clarityStoreFactory("serviceSpecialty"),

  clarityReportingTool: clarityStoreFactory("reportingTool"),

  clarityReportingGeneration: clarityStoreFactory("reportingGeneration"),

  clarityReportingRegistry: clarityStoreFactory("reportingRegistry"),

  clarityServicePharmacy: clarityStoreFactory("servicePharmacy"),

  clarityServiceOther: clarityStoreFactory("serviceOther"),

  clarityServiceBehavioralProgram: clarityStoreFactory(
    "serviceBehavioralProgram"
  ),

  clarityGender: clarityStoreFactory("clarityGender"),

  clarityGrouperMicrs: clarityStoreFactory("clarityGrouperMicrs"),

  clarityGrouperOshpd: clarityStoreFactory("clarityGrouperOshpd"),

  clarityGrouperUds: clarityStoreFactory("clarityGrouperUds"),

  clarityLanguage: clarityStoreFactory("clarityLanguage"),

  clarityLicenseForDisplay: clarityStoreFactory("clarityLicenseForDisplay"),

  clarityState: clarityStoreFactory("clarityState"),

  clarityTypeOfStaff: clarityStoreFactory("clarityTypeOfStaff"),

  clarityReferralSourceType: clarityStoreFactory("clarityReferralSourceType"),

  clarityProviderType: clarityStoreFactory("clarityProviderType"),

  clarityProviderSpecialty: clarityStoreFactory("clarityProviderSpecialty"),

  clarityCounty: clarityStoreFactory("clarityCounty"),

  clarityZip: clarityStoreFactory("clarityZip"),
};
